import { Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import useStyles from './index.styles'

interface ActiveTabsProps {
  title: string
  value: string
  setValue: React.Dispatch<React.SetStateAction<string>>
}

export default function PermissionActiveTabs({
  title,
  value,
  setValue
}: ActiveTabsProps) {
  const classes = useStyles()
  const tabs = ['All', 'Role-Based', 'User-Based', 'Not-Selected']

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>{getTranslate(title)}</Typography>
      <div className={classes.main}>
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`${classes.item} ${value === tab ? classes.active : ''}`}
            onClick={() => setValue(tab)}>
            {getTranslate(tab)}
          </div>
        ))}
      </div>
    </div>
  )
}
